import compose from 'crocks/helpers/compose';
import constant from 'crocks/combinators/constant';
import unary from 'crocks/helpers/unary';
import mapProps from 'crocks/helpers/mapProps';
import unless from 'crocks/logic/unless';
import isNumber from 'crocks/predicates/isNumber';
import { get } from '@appnest/lit-translate';

const ensureIndex = unless(isNumber, constant(-1));
const parseIndexAttr = compose(ensureIndex, unary(parseInt));

/**
 * Casts String `*index` values to Number
 * @type {Function}
 * @param {* & {columnIndex: any, rowIndex: any, index: any}} args
 * @return {* & {columnIndex: Number, rowIndex: Number, index: Number}}
 */
export const parseIndexes = mapProps({
  columnIndex: parseIndexAttr,
  rowIndex: parseIndexAttr,
  index: parseIndexAttr,
});

const translateExists = ([char]) => char !== '[';

/**
 * Translates a key if possible and desired.
 * @param  {String}  path                    Translation key
 * @param  {Boolean} [shouldTranslate=false] Whether or not to translate
 * @return {String}
 */
export const safeTrans = (path, shouldTranslate = false) =>
    shouldTranslate &&
    path &&
    translateExists(get(path))
      ? get(path)
      : path;
